export class FormDataDTO {

  LABEL: string;
  TYPE: string;
  VALUE: string;
  ID: string;
  SELECTED: boolean | null;
  CLASS: string;
  ORDER: number | null;

  constructor(label, type, value, id, Class, order = 0, checked?) {

    this.LABEL = label;
    this.TYPE = type;
    this.VALUE = value;
    this.ID = id;
    this.CLASS = Class;
    this.ORDER = order;
    this.SELECTED = checked ?? null;

  }
}